import $ from 'jquery';

$(document).ready(() => {

    // Smooth-scroll to in-page anchors. Section IDs are editor-configurable, so
    // bail out rather than throw when the target section isn't on the page.
    $('.js-scroll-link').click((e) => {
        const href = $(e.currentTarget).attr('href');
        if (!href || !href.startsWith('#')) return;

        const $target = $(href);
        if (!$target.length) return;

        e.preventDefault();
        $('html, body').animate({
            scrollTop: $target.offset().top
        }, 500);
    })

    // Switch header nav link colour based on the background tone of the
    // section currently sitting beneath the fixed header. Every section is dark
    // in this theme, so the default (light) links apply throughout; a section
    // emitting data-header-tone="light" flips them to dark.
    const header = document.getElementById('site-header');
    const sections = Array.from(document.querySelectorAll('[data-header-tone]'));

    if (header && sections.length) {
        const updateHeaderTone = () => {
            // Sample just below the header's bottom edge.
            const line = header.getBoundingClientRect().bottom + 1;
            let tone = null;

            for (const section of sections) {
                const rect = section.getBoundingClientRect();
                if (rect.top <= line && rect.bottom > line) {
                    tone = section.getAttribute('data-header-tone');
                    break;
                }
            }

            header.classList.toggle('header-over-light', tone === 'light');
        };

        updateHeaderTone();
        window.addEventListener('scroll', updateHeaderTone, { passive: true });
        window.addEventListener('resize', updateHeaderTone);
    }

    // Fade the hero video in once it has a frame to show. Until then the
    // static gradient and house motif underneath carry the hero, rather than
    // the viewer staring at a black box while tens of megabytes buffer.
    const heroVideo = document.querySelector('[data-hero-video]');

    if (heroVideo) {
        heroVideo.classList.add('js-video-fade');

        const revealVideo = () => heroVideo.classList.add('is-loaded');

        // HAVE_FUTURE_DATA or better means a frame is already decoded.
        if (heroVideo.readyState >= 3) {
            revealVideo();
        } else {
            heroVideo.addEventListener('canplay', revealVideo, { once: true });
            heroVideo.addEventListener('loadeddata', revealVideo, { once: true });
        }
    }

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Fade content sections in as they scroll into view. Reveal immediately
    // (no animation) when reduced motion is preferred or IntersectionObserver
    // is unavailable, so content is never left hidden.
    const revealItems = Array.from(document.querySelectorAll('.js-reveal'));

    if (revealItems.length) {
        if (prefersReducedMotion || !('IntersectionObserver' in window)) {
            revealItems.forEach((el) => el.classList.add('is-visible'));
        } else {
            const revealObserver = new IntersectionObserver((entries, observer) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('is-visible');
                        observer.unobserve(entry.target);
                    }
                });
            }, { rootMargin: '0px 0px -10% 0px', threshold: 0.15 });

            revealItems.forEach((el) => revealObserver.observe(el));
        }
    }
})
